var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-log" },
    [
      _c("div", { staticClass: "s-con" }, [
        _vm.applySignInfo
          ? _c(
              "div",
              { staticClass: "apply-info" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      placement: "bottom-start",
                      disabled: _vm.applySignInfo.contractName.length < 50,
                      content: _vm.applySignInfo.contractName
                    }
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "font-ellipsis l-title",
                        staticStyle: { width: "70%" }
                      },
                      [
                        _c("i"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("ellipsis")(
                                _vm.applySignInfo.contractName,
                                50
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                ),
                _c("p", [
                  _c("span", [
                    _vm._v("文件编号：" + _vm._s(_vm.applySignInfo.applyNo))
                  ]),
                  _c("span", [
                    _vm._v(
                      "发起时间：" +
                        _vm._s(
                          _vm._f("formatDateTime")(_vm.applySignInfo.createTime)
                        )
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "signStatus",
                      class: "s" + _vm.applySignInfo.signStatus
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.statusText) + "\n        "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.applySignInfo
          ? _c(
              "div",
              { staticClass: "s-btn-box" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "m-btn",
                    attrs: { size: "small" },
                    on: { click: _vm.turnEivHand }
                  },
                  [
                    _c("span", {
                      staticClass: "el-icon-view",
                      staticStyle: { "margin-right": "10px", color: "#EC1C1C" }
                    }),
                    _vm._v("全证据链\n      ")
                  ]
                ),
                _vm.applySignInfo &&
                [1, 4, 5].includes(_vm.applySignInfo.signStatus)
                  ? [
                      _vm.applySignInfo.videnceFile
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "el-button btn el-button--danger el-button--small z-btn",
                              attrs: {
                                href: _vm.downloadAttatchFile(
                                  _vm.applySignInfo.videnceFile || null
                                ),
                                target: "_blank"
                              }
                            },
                            [
                              _c("i", { staticClass: "t1" }),
                              _c("i", { staticClass: "t1 on" }),
                              _vm._v("证据包下载\n        ")
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                [1, 4, 5].includes(
                                  (_vm.applySignInfo || {}).signStatus
                                ) &&
                                _vm.applySignInfo.createType === 1 &&
                                _vm.$store.getters.hasAuthUser,
                              expression:
                                "\n            [1,4,5].includes((applySignInfo || {}).signStatus) &&\n            applySignInfo.createType === 1 &&\n            $store.getters.hasAuthUser\n          "
                            }
                          ],
                          staticClass: "z-btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              _vm.printCordDialog = true
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "t3" }),
                          _c("i", { staticClass: "t3 on" }),
                          _vm._v("防伪打印记录\n        ")
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "s-table-wrap" },
          [
            _vm.applySignInfo
              ? _c(
                  "el-table",
                  {
                    staticClass: "file-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.applySignInfo.fileInfos,
                      "ooltip-effect": "dark",
                      "empty-text": "暂无数据",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "签署文件", "min-width": "187" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [_vm._v(_vm._s(scope.row.fileName))]
                            }
                          }
                        ],
                        null,
                        false,
                        3350986140
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.applySignInfo
              ? _c(
                  "el-table",
                  {
                    staticClass: "table-info",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.applySignInfo.signInfos,
                      "tooltip-effect": "dark",
                      "empty-text": "暂无数据",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "签署方",
                        "show-overflow-tooltip": "",
                        "min-width": "187"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.fullName) +
                                    "\n            "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.identityCardMask) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3793446263
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "签署流水号",
                        prop: "signNo",
                        "min-width": "187",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "签署状态", width: "160px" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.signStatus === 1
                                  ? _c(
                                      "span",
                                      { staticClass: "color-danger" },
                                      [_vm._v("已签署")]
                                    )
                                  : scope.row.signStatus === 2
                                  ? _c(
                                      "span",
                                      { staticClass: "color-danger" },
                                      [_vm._v("拒签")]
                                    )
                                  : _c("span", [_vm._v("未签署")])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        684571740
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "签署时间",
                        "show-overflow-tooltip": "",
                        "min-width": "160px"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("formatDateTime")(
                                        scope.row.signTime
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        2038628151
                      )
                    }),
                    _c("el-table-column", {
                      staticStyle: { overflow: "auto" },
                      attrs: {
                        label: "签署现场",
                        prop: "address",
                        "class-name": "table-cloumn",
                        "min-width": "120"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "mas-wrap" },
                                  [
                                    scope.row.evidenceList &&
                                    scope.row.evidenceList.length
                                      ? _c(
                                          "el-badge",
                                          {
                                            staticClass: "badge-evidence",
                                            attrs: {
                                              value:
                                                scope.row.evidenceList.length
                                            }
                                          },
                                          [
                                            _c("div", { staticClass: "msk" }, [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showEvidence(
                                                        scope.row.evidenceList
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-view"
                                                  }),
                                                  _vm._v(
                                                    "预览\n                  "
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("img", {
                                              attrs: {
                                                src: _vm._f("showFiles")(
                                                  scope.row.evidenceList[0]
                                                    .evidenceImg
                                                ),
                                                alt: ""
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2471572495
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.newVideoInfo
              ? _c(
                  "el-table",
                  {
                    staticClass: "file-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.newVideoInfo,
                      "ooltip-effect": "dark",
                      "empty-text": "暂无数据",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "视频通话记录" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.videoFile
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          scope.row.realStartTime
                                            ? scope.row.realStartTime
                                            : scope.row.endTime
                                            ? scope.row.endTime
                                            : scope.row.startTime
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.anchor.signatoryFullName
                                        )
                                      )
                                    ]),
                                    _vm._l(scope.row.participants, function(
                                      item
                                    ) {
                                      return _c("p", { key: item.signNo }, [
                                        _vm._v(_vm._s(item.signatoryFullName))
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2662782605
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.videoFile
                                  ? _c("div", [
                                      _c(
                                        "video",
                                        {
                                          attrs: {
                                            width: "300",
                                            height: "150",
                                            controls: "",
                                            autoplay: "",
                                            muted: ""
                                          },
                                          domProps: { muted: true }
                                        },
                                        [
                                          _c("source", {
                                            attrs: {
                                              src:
                                                _vm.GlobalConfig.domain
                                                  .junziqianApi +
                                                "/fileOper/download?fileType=" +
                                                scope.row.videoFile.fileType +
                                                "&sign=" +
                                                scope.row.videoFile.sign +
                                                "&targetId=" +
                                                scope.row.videoFile.targetId +
                                                "&ts=" +
                                                scope.row.videoFile.ts,
                                              type: "video/mp4"
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1833197657
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.attatchInfo.length > 0
              ? _c(
                  "el-table",
                  {
                    staticClass: "table-info",
                    staticStyle: { width: "100%", "margin-top": "20px" },
                    attrs: {
                      data: _vm.attatchInfo,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "附件名称",
                        width: "425px",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(attatch) {
                              return _c("span", {}, [
                                _vm._v(_vm._s(attatch.row.file.fileName))
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        3919685923
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "附件编号",
                        prop: "attatchId",
                        width: "320px"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "大小", width: "225px" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(attatch) {
                              return _c("span", {}, [
                                _vm._v(
                                  _vm._s(attatch.row.file.fileSize / 1000) + "k"
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        1314505455
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(attatch) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "color-success",
                                    attrs: {
                                      href: _vm.downloadAttatchFile(
                                        attatch.row.file
                                      ),
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("下载文件")]
                                ),
                                _vm.isImg(attatch.row) ||
                                _vm.isVideo(attatch.row)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        staticStyle: {
                                          "margin-left": "20px",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewVideOrImg(
                                              attatch.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("预览")]
                                    )
                                  : _vm._e(),
                                _vm.isDoc(attatch.row)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        staticStyle: {
                                          "margin-left": "20px",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewDoc(attatch.row)
                                          }
                                        }
                                      },
                                      [_vm._v("预览")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2392480333
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: { "text-align": "right", padding: "10px 40px 0 0" }
              },
              [
                _vm.allDownloadFileData
                  ? _c(
                      "div",
                      {
                        staticClass: "color-success",
                        staticStyle: {
                          cursor: "pointer",
                          display: "inline-block"
                        },
                        on: { click: _vm.downloadAllFileFn }
                      },
                      [_vm._v("下载全部附件")]
                    )
                  : _vm._e()
              ]
            ),
            _vm.LYList.length > 0
              ? _c(
                  "el-table",
                  {
                    staticClass: "table-info",
                    staticStyle: { width: "100%", "margin-top": "20px" },
                    attrs: {
                      data: _vm.LYList,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "履约文件", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.fileName) +
                                    "\n            "
                                ),
                                _c("br"),
                                scope.row.uploadType == 2
                                  ? _c(
                                      "label",
                                      { staticStyle: { color: "#999999" } },
                                      [
                                        _vm._v(
                                          "备案号：" + _vm._s(scope.row.presId)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        3249592713
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "类型" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      scope.row.uploadType == 1
                                        ? "原文件"
                                        : "哈希"
                                    ) +
                                    "\n          "
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        2826483855
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "上传人" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  _vm._s(scope.row.userName) +
                                    "-" +
                                    _vm._s(scope.row.accountName)
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        3685590266
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "上传时间" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("formatDateTime")(
                                        scope.row.uploadTime
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        false,
                        5021607
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.uploadType == 1
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        attrs: {
                                          href: _vm.downloadAttatchFile(
                                            scope.row.file
                                          ),
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v("下载")]
                                    )
                                  : _vm._e(),
                                scope.row.uploadType == 2
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.validLYFile(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("验证")]
                                    )
                                  : _vm._e(),
                                _vm.isImg(scope.row) || _vm.isVideo(scope.row)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        staticStyle: {
                                          "margin-left": "20px",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewVideOrImg(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("预览")]
                                    )
                                  : _vm._e(),
                                _vm.isDoc(scope.row)
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "color-success",
                                        staticStyle: {
                                          "margin-left": "20px",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewDoc(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("预览")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3528818556
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.videoSignList && _vm.videoSignList.length
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "video-sign",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("h3", [_vm._v("视频签署")]),
                      _c(
                        "el-table",
                        {
                          staticClass: "table-info",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.videoSignList,
                            "tooltip-effect": "dark",
                            "header-cell-style": {
                              background: "#f9f9f9",
                              color: "#333333",
                              fontWeight: "500"
                            }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "录制开始时间" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _c("span", {}, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              scope.row.startTime
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  }
                                }
                              ],
                              null,
                              false,
                              2108641732
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "录制完成时间" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _c("span", {}, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              scope.row.endTime
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  }
                                }
                              ],
                              null,
                              false,
                              3343142571
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "视频时长" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.duration
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("secToTime")(
                                                    scope.row.duration
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2794874395
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "视频大小" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.fileSize
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  Math.ceil(
                                                    (scope.row.fileSize /
                                                      1024 /
                                                      1024) *
                                                      100
                                                  ) / 100
                                                ) +
                                                "Mb\n                "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              903558862
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "参与人",
                              prop: "signNames",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._m(0),
      _c("process-evidence", {
        attrs: { show: _vm.sdetailsDialog },
        on: {
          "update:show": function($event) {
            _vm.sdetailsDialog = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          ref: "evidenceBox",
          staticClass: "show-evidence__dailog",
          attrs: {
            visible: _vm.visibleShowEvidence,
            width: "70%",
            "modal-append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleShowEvidence = $event
            }
          }
        },
        [
          _vm.evidenceList && _vm.evidenceList.length
            ? _c(
                "el-carousel",
                {
                  attrs: {
                    height: "500px",
                    autoplay: false,
                    "indicator-position": "none",
                    arrow: "always"
                  }
                },
                _vm._l(_vm.evidenceList, function(item, i) {
                  return item.evidenceImg
                    ? _c(
                        "el-carousel-item",
                        {
                          key: i,
                          ref: "contbox-" + i,
                          refInFor: true,
                          staticClass: "img-item"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "video-box",
                              staticStyle: { display: "none" }
                            },
                            [
                              _c(
                                "video",
                                {
                                  attrs: {
                                    controls: "controls",
                                    height: "500px"
                                  }
                                },
                                [
                                  _c("source", {
                                    attrs: { src: "", type: "video/mp4" }
                                  }),
                                  _c("source", {
                                    attrs: { src: "", type: "video/webm" }
                                  }),
                                  _c("source", {
                                    attrs: { src: "", type: "video/ogg" }
                                  }),
                                  _vm._v("您的浏览器不支持视频播放\n          ")
                                ]
                              )
                            ]
                          ),
                          _c("div", { staticClass: "img-box" }, [
                            _c("img", {
                              attrs: {
                                src: _vm._f("showFiles")(item.evidenceImg),
                                alt: ""
                              }
                            }),
                            item.evidenceVideo
                              ? _c("img", {
                                  staticClass: "play-video",
                                  attrs: { src: "/images/m/play.png", alt: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.playEvidenceVideo(
                                        item.evidenceVideo || null,
                                        "contbox-" + i
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          ref: "addressBox",
          staticClass: "show-evidence__dailog",
          attrs: {
            visible: _vm.visibleShowAddress,
            width: "70%",
            "modal-append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleShowAddress = $event
            }
          }
        },
        [
          _c(
            "el-carousel",
            {
              attrs: {
                height: "500px",
                autoplay: false,
                "indicator-position": "none",
                arrow: "never"
              }
            },
            [
              _c("el-carousel-item", { staticClass: "img-item" }, [
                _c("div", { staticClass: "img-box" }, [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: { src: _vm.addressImg }
                  })
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          ref: "addressBox",
          attrs: {
            visible: _vm.printCordDialog,
            title: "防伪打印记录",
            width: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.printCordDialog = $event
            }
          }
        },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.applySignInfo || {}).createType === 1 &&
                  _vm.$store.getters.hasAuthUser &&
                  _vm.applySignInfo.signStatus == 1,
                expression:
                  "\n        (applySignInfo || {}).createType === 1 &&\n        $store.getters.hasAuthUser &&\n        applySignInfo.signStatus == 1\n      "
              }
            ],
            staticStyle: { "text-align": "right" }
          }),
          _c(
            "el-table",
            { attrs: { data: _vm.printList, "tooltip-effect": "dark" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "文件名称",
                  prop: "fileName",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "文件哈希",
                  prop: "docHash",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "防伪编码",
                  prop: "printNo",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "时间",
                  prop: "createTime",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", { attrs: { label: "IP", prop: "ip" } }),
              _c("el-table-column", {
                attrs: { label: "操作账号", prop: "printer" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.certiDialog,
            title: "选择出证签署方",
            width: "30%",
            top: "30vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.certiDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "flex-wrap": "wrap",
                padding: "10px 0 20px"
              }
            },
            [
              _vm._l(_vm.certiList, function(item, index) {
                return [
                  _c(
                    "el-button",
                    {
                      key: index,
                      staticStyle: { "margin-right": "10px" },
                      on: {
                        click: function($event) {
                          return _vm.selectCerti(item)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.idenName))]
                  )
                ]
              })
            ],
            2
          )
        ]
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sign-info" }, [
      _c("p", { staticClass: "t-info color-success" }, [
        _vm._v("什么是证据包？")
      ]),
      _c("p", { staticClass: "t-info" }, [
        _vm._v(
          "证据包是将签署过程中产生的一系列证据打包存档，包含签署过程日志、签署现场添加的附件、签署文件，如产生文件纠纷，可作为完整的证据链用于法庭举证"
        )
      ]),
      _c(
        "p",
        {
          staticClass: "t-info color-success",
          staticStyle: { "margin-top": "15px" }
        },
        [_vm._v("什么是证据包出证？")]
      ),
      _c("p", { staticClass: "t-info" }, [
        _vm._v(
          "证据包用于法庭举证时，如需要纸质的公证书等，可以直接在线出具，邮寄到家。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32b31082", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b31082","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/applySign/toSignlog.vue
// module id = pdBo
// module chunks = 85